import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./CreditCardPaymentQuote.module.css";
import tutorialImg1 from "../../../assets/img/TutorialImg1.png";
import { InputText } from "primereact/inputtext";
import { GetHashCursos } from "../../../utils/GeHash";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getTokenInfo } from "../../../utils/Guard";
import { useDispatch, useSelector } from "react-redux";
import { GetCourse } from "../../../store/course-store/course-actions";
import {
  AddUser,
  GetOrdensById,
  RemoveUser,
  UpdateBillingInfo,
  UpdatePaymenMethod,
  UploadFileOrder,
} from "../../../store/orden-store/orden-actions";
import Loading from "../../../components/loading/Loading";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { userActions } from "../../../store/auth-store/auth-slice";
import { uiActions } from "../../../store/ui-slice";
import { CleanUser, GetUserById } from "../../../store/auth-store/auth-actions";
import { Dialog } from "primereact/dialog";
import DialogModal from "../../../components/dialogModal/DialogDialogModal";
import ABADatatable from "../../../components/abaDataTable/ABADatatable";
import { FileUpload } from "primereact/fileupload";
import { InputMask } from "primereact/inputmask";
import { Dropdown } from "primereact/dropdown";
import { countriesArray } from "../../../components/List";
import { Checkbox } from "primereact/checkbox";
import { VerifyDiscountCode } from "../../../store/discount-store/discount-actions";
import { ordenActions } from "../../../store/orden-store/orden-slice";

let callOnce = true;
let callOnce2 = true;
let oldDiscountCode = "";
let inputColor = false;


const CreditCardPaymentQuote = () => {
  const param = useParams();
  const userInfo = getTokenInfo();
  const stepperRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const orden = useSelector((state) => state.orden.orden);
  const course = useSelector((state) => state.course.course);
  const user = useSelector((state) => state.auth.auth);
  const notification = useSelector((state) => state.ui.notification);
  const [amountDollar, setAmountDollar] = useState(0);
  const [amountRD, setAmountRD] = useState(0);
  const [count, setCount] = useState(1);
  const [priceWithDiscount, setPriceWithDiscount] = useState(0);
  const [visibleUser, setVisibleUser] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [users, setUsers] = useState([]);
  const [showDiscount, setShowDiscount] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(0);
  const [showTutorial, setShowTutorial] = useState(true);
  const [invalidField, setInvalidField] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(
    ""
  );
  const [countries, setCountries] = useState([]);
  const fileUploadRef = useRef(null);
  const country = countriesArray;
  const [loadUserInfo, setLoadUserInfo] = useState(false);
  const discount = useSelector((state) => state.discount.discount);  

  console.log(orden);
  

  useEffect(() => {
    if (userInfo !== undefined &&
      userInfo !== null &&
      userInfo.UserId !== undefined &&
      userInfo.UserId !== null
      && orden.discountCode !== undefined && orden.discountCode !== null && orden.discountCode !== ""
    ) {
      inputColor = true;
      dispatch(VerifyDiscountCode(userInfo.Email, orden.discountCode, param.courseid));

    }

  }, [orden.discountCode]);

  useEffect(() => {
    if (user !== undefined && user !== null && loadUserInfo) {
      dispatch(GetUserById(userInfo.UserId, userInfo.Email, "", false));

      const foundCountry = country.find(
        (country) => country.name === user.country
      );

      if (foundCountry !== undefined && foundCountry !== null) {
        const countryWithCode = {
          ...foundCountry,
          code: foundCountry.name,
          flag: foundCountry.abreviatura,
        };
        delete countryWithCode.abreviatura;
        onChangeCountriesHandler("countryid", countryWithCode);

      }
    }
  }, [loadUserInfo, user.id]);

  useEffect(() => {
    if (country !== undefined && country.length > 0) {
      var id = 0;
      const listCountries = country.map((country) => {
        id++;
        return {
          code: country.name,
          name: country.name,
          flag: country.abreviatura,
        };
      });
      setCountries(listCountries);
    }
  }, [country]);


  useEffect(() => {
    if (orden.id === undefined || orden.id === null || orden.id === 0) {
      if (callOnce2) {
        dispatch(GetOrdensById(param.ordenid, userInfo.Email));
        callOnce2 = false;
      }
    }
  }, [orden, userInfo, dispatch]);

  let amountToPay = "0";

  useEffect(() => {
    if (notification !== null && notification !== undefined && notification.message !== null && notification.message !== undefined && (notification.message === "Curso no encontrado." || notification.message === "No se encontro la orden." || notification.message === "No se pudo obtener las ordenes")) {
      window.location.href = "/courses/none";
    }
  }, [notification]);

  useEffect(() => {
    if (notification !== null && notification !== undefined && notification.status !== null && notification.status !== undefined && notification.title == "Participante Agregado") {

      setVisibleUser(false);
      window.location.reload();
    }
  }, [notification]);


  useEffect(() => {
    if (
      course === undefined ||
      course === null ||
      course.id === null ||
      course.id === undefined ||
      course.id === 0
    ) {
      if (
        userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== null &&
        userInfo.UserId !== undefined &&
        param.courseid !== undefined &&
        callOnce
      ) {
        callOnce = false;
        dispatch(
          GetCourse(param.courseid, userInfo.UserId, "aulaaba.aba.org.do")
        );
      } else {
        if (callOnce) {
          callOnce = false;
          dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
        }
      }
    }
  }, [course, dispatch, param.courseid, userInfo]);

  useEffect(() => {
    if (orden && orden.discount && orden.discount.id > 0) {
      let userCount = 0;
      orden.users.forEach((user) => {
        if (user.id !== 0) {
          userCount++;
        }
      });
      

      if (!orden.discount.grupal) {
        setShowDiscount(true);
        if (orden.discount.percentage) {
          const discount =
            course.price * (orden.discount.discountPercentage / 100);
          setPriceWithDiscount(course.price - discount);
        } else {
          setPriceWithDiscount(course.price - orden.discount.discountNominal);
        }
      } else if (orden.discount.grupal && userCount >= 3) {
        setShowDiscount(true);
        if (orden.discount.percentage) {
          const discount =
            course.price * (orden.discount.discountPercentage / 100);
          setPriceWithDiscount(course.price - discount);
        } else {
          setPriceWithDiscount(course.price - orden.discount.discountNominal);
        }
      }
    }
  }, [course.price, orden]);

  const CancelUrl =
    process.env.REACT_APP_MERCHANTID_URL + "courseInfo/" + param.courseid;
  const ApprovedUrl =
    process.env.REACT_APP_MERCHANTID_URL + "approvedtransaction";

  const DeclinedUrl =
    process.env.REACT_APP_MERCHANTID_URL + "deniedtransaction";

  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  let moneyFormat = new Intl.NumberFormat("en-US", {
    // style: "currency",
    currency: "USD",
    useGrouping: false,
    minimumFractionDigits: 2,
  });

  useEffect(() => {
    if (
      orden &&
      orden.id !== undefined &&
      orden.id !== 0 &&
      course.id !== 0 &&
      course.id !== undefined &&
      course.id !== null &&
      orden.users !== undefined &&
      orden.users !== null
    ) {
      if (
        orden.discount &&
        orden.discount.id !== undefined &&
        orden.discount.id !== 0 &&

        count > 0
      ) {
        let discount = 0;
        let count = 0;

        orden.users.forEach((user) => {
          if (user.id !== 0) {
            count++
          }
        });

        if (orden.discount.percentage) {
          discount =
            course.price * count * (orden.discount.discountPercentage / 100);
        }
        if (orden.discount.nominal) {
          discount = orden.discount.discountNominal * count;
        }


        const dollar = (course.price * count) - discount;

        console.log(orden.dollarRate);
        
        const rd = Math.round(dollar * orden.dollarRate);


        setAmountDollar(dollar > 0 ? dollar : 0);
        setAmountRD(rd > 0 ? rd : 0);
      } else {
        let count = 0;

        orden.users.forEach((user) => {
          if (user.id !== 0) {
            count++
          }
        });

        const dollar = (course.price * count);
        const rd = dollar * orden.dollarRate;

        setAmountDollar(dollar > 0 ? dollar : 0);
        setAmountRD(rd > 0 ? rd : 0);
      }
    }
  }, [orden, count, course]);


  useEffect(() => {
    if (orden && orden.discount && orden.discount.id > 0) {
      let userCount = 0;
      orden.users.forEach((user) => {
        if (user.id !== 0) {
          userCount++;
        }
      });
      

      if (!orden.discount.grupal) {
        setShowDiscount(true);
        if (orden.discount.percentage) {
          const discount =
            course.price * (orden.discount.discountPercentage / 100);
          setPriceWithDiscount(course.price - discount);
        } else {
          setPriceWithDiscount(course.price - orden.discount.discountNominal);
        }
      } else if (orden.discount.grupal && userCount >= 3) {
        setShowDiscount(true);
        if (orden.discount.percentage) {
          const discount =
            course.price * (orden.discount.discountPercentage / 100);
          setPriceWithDiscount(course.price - discount);
        } else {
          setPriceWithDiscount(course.price - orden.discount.discountNominal);
        }
      }
    }
  }, [course.price, orden]);


  amountToPay = moneyFormat.format(amountRD);

  const checkHandler = (e) => {

    setLoadUserInfo(e.checked)

    if (loadUserInfo) {
      dispatch(CleanUser());
      setSelectedCountry("");
    }
  };

  const addUserHandler = async () => {
    if (user.name === "" || user.name === undefined || user.name === null) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: "El campo nombre es requerido",
        })
      );
      return;
    }
    if (
      user.lastName === "" ||
      user.lastName === undefined ||
      user.lastName === null
    ) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: "El campo apellido es requerido",
        })
      );
      return;
    }
    if (user.email === "" || user.email === undefined || user.email === null) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: "El campo correo es requerido",
        })
      );
      return;
    }

    if (
      user.cellPhone === "" || user.cellPhone === undefined || user.cellPhone === null
    ) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: "El campo teléfono es requerido",
        })
      );
      return;
    }

    if (
      user.country === "" || user.country === undefined || user.country === null
    ) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error",
          message: "El campo país es requerido",
        })
      );
      return;
    }

    if (users.find((x) => x.email === user.email) === undefined) {
      if (user !== undefined && (user.name === undefined || user.name === "")) {
        dispatch(userActions.setFieldValid({ id: "name", value: false }));
        return;
      }
      if (
        user !== undefined &&
        (user.lastName === undefined || user.lastName === "")
      ) {
        dispatch(userActions.setFieldValid({ id: "lastName", value: false }));
        return;
      }
      if (
        user !== undefined &&
        (user.email === undefined || user.email === "")
      ) {
        dispatch(userActions.setFieldValid({ id: "email", value: false }));
        return;
      }

      if (
        user !== undefined &&
        (user.cellPhone === undefined || user.cellPhone === "")
      ) {
        dispatch(userActions.setFieldValid({ id: "cellPhone", value: false }));
        return;
      }
      if (
        user.country !== undefined &&
        (user.country === undefined || user.country === "")
      ) {
        dispatch(userActions.setFieldValid({ id: "country", value: false }));
        return;
      }

      dispatch(AddUser(param.ordenid, user, userInfo.Email, false));
      // dispatch(userActions.restartState());
    }
  };

  const onSubmitBillingHandler = async () => {

    setInvalidField("");

    if (user.name === "") {
      dispatch(
        uiActions.showNotification({
          message: "El nombre es requerido",
          status: "warning",
        })
      );
      setInvalidField("name");
      return;
    } else if (user.email === "") {
      dispatch(
        uiActions.showNotification({
          message: "El email es requerido",
          status: "warning",
        })
      );
      setInvalidField("email");
      return;
    } else if (user.lastName === "") {
      dispatch(
        uiActions.showNotification({
          message: "El apellido es requerido",
          status: "warning",
        })
      );
      setInvalidField("lastName");
      return;
    }
    else if (user.cellPhone === "") {
      dispatch(
        uiActions.showNotification({
          message: "El teléfono es requerido",
          status: "warning",
        })
      );
      setInvalidField("cellPhone");
      return;
    }
    else if (user.address === "") {
      dispatch(
        uiActions.showNotification({
          message: "La dirección es requerida",
          status: "warning",
        })
      );
      setInvalidField("address");
      return;
    }
    else if (!selectedCountry) {
      dispatch(
        uiActions.showNotification({
          message: "El país es requerido",
          status: "warning",
        })
      );
      setInvalidField("country");
      return;
    }
    
    let count = 0;
    for(let i = 0; i < orden.users.length; i++) {
      if (orden.users[i].id !== 0) {
        count++;
      }
    }
    const amount = course.price *count; 
   
    
    const billing = {
      ordenId: orden.id,
      billNumber: orden.id,
      billName: user.name + " " + user.lastName,
      billAddress: user.address,
      billCountry: selectedCountry.code,
      billEmail: user.email,
      billPhone: user.cellPhone,
      billAmount: amount,
      amount: amount,
      discountCode: discount.isValid ? orden.discountCode : oldDiscountCode,
    };

    dispatch(UpdateBillingInfo(billing, userInfo.Email));

    dispatch(CleanUser());
    setLoadUserInfo(false);
    stepperRef.current.nextCallback()
  }

  const onChangeHandler = (id, value) => {
    if (id !== "charge" && id !== "department") {
      dispatch(userActions.modifyPropertyValue({ id, value }));
      if (value !== "") {
        dispatch(userActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    } else {
      dispatch(userActions.modifyPropertyValue({ id, value: { id: value } }));
    }
  };


  const removeUserHandler = async (id) => {
    await dispatch(RemoveUser(param.ordenid, id, course.price, userInfo.Email));
    window.location.reload();
  };

  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCountry({
      code: value.code,
      name: value.name,
      flag: value.flag,
    });
  };

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.name}
            src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
            style={{ width: "18px" }}
          />
          <div style={{ marginLeft: "5%" }}>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const columns = [
    {
      // field: "id",
      header: "Id del usuario",
      filterMatchMode: "contains",
      body: (rowData) => {
        return (
          <div>
            {rowData.id == 0 || rowData.id == null || rowData.id == undefined
              ? "Agregar un usuario"
              : rowData.id}
          </div>
        );
      },
    },
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },
    {
      field: "email",
      header: "Correo",
      filterMatchMode: "contains",
    },
    {
      // field: "creationDate",
      header: "Fecha",
      filterMatchMode: "contains",
      body: (rowData) => {
        return (
          <div>
            {rowData.id == 0 ? null : (
              <span>{rowData.creationDate.split("T")[0]}</span>
            )}
          </div>
        );
      },
    },
  ];

  const rowClassName = (rowData) => {

    return rowData.id == 0 || rowData.id == null || rowData.id == undefined
      ? styles.noIdRow
      : null;
  };

  const openAddUserModal = () => {
    dispatch(CleanUser());
    setVisibleUser(true);
  };

  const countryOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center" style={{ width: "100px" }}>
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "5%" }}>{option.name}</div>
      </div>
    );
  };

  const onChangeDiscountHandler = (id, value) => {

    if (id === "discountCode") {
      dispatch(ordenActions.modifyPropertyValue({ id, value }));
    }

  };

  const modifiedUsers = useMemo(() => {
    if (orden !== null && orden !== undefined && orden.users !== undefined && orden.users !== null && orden.users.every(user => user.id !== 0)) {
      return [
        ...orden.users,
        {
          id: 0,
          ordenId: 0,
          email: '',
          name: '',
          lastName: '',
          identification: '',
          cellPhone: '',
          country: '',
          city: '',
          address: '',
          status: false,
          hubspotId: 0,
          networking: false,
          assitance: false,
          certificateSent: false,
          conferecenCodeName: '',
          newPassword: '',
          password: '',
          temporalPassword: false,
          creationUser: '',
          creationDate: '0001-01-01T00:00:00',
          updateDate: '0001-01-01T00:00:00',
          updateUser: '',
          company: null,
          companyId: 0,
          charge: null,
          chargeId: 0,
          department: null,
          departmentId: 0,
          tokenValidation: null,
          ordens: null,
          courseModules: null,
          courseId: 0,
          conferecenId: 0,
          userName: '',
          photoURL: '',
          signatureURL: '',
          resume: '',
          file: null,
          data: null,
          photo: null,
          signature: null
        }
      ];
    }
    return orden.users;
  }, [orden.users]);

  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonBuy =
      rowData.id != 0 ? (
        <Button
          icon="pi pi-times"
          className="p-button-rounded p-button-text buy-button"
          style={{ color: "#D1432F", fontWeight: "bold" }}
          onClick={() => {
            removeUserHandler(rowData.id);
          }}
        />
      ) : (
        <Button
          icon="pi pi-plus"
          className="p-button-rounded p-button-text buy-button"
          style={{ color: "#0DC24C", fontWeight: "bold" }}
          onClick={() => {
            openAddUserModal();
          }}
        />
      );

    // if (auth.roles !== undefined && auth.roles.includes("charge.edit")) {
    buttons.push(buttonBuy);
    // }
    // if (auth.roles !== undefined && auth.roles.includes("charge.view")) {

    // }
    return buttons;
  };
  actions.push(buttons);

  return (
    <>
      <Stepper ref={stepperRef}>
        <StepperPanel header="quote">
          <div className={styles.CreditCardPaymentQuote}>
            {orden.id !== null &&
              orden.id !== undefined &&
              orden.id > 0 && (<>

                <h1 className={styles.formTitle}>¿Quienes van a tomar el curso?</h1>

                <ABADatatable
                  showAddButton={true}
                  width="20%"
                  values={modifiedUsers}
                  rows={20}
                  Columns={columns}
                  actions={actions}
                  alwaysShowPaginator={false}
                  dontshowMenu
                  rowClassName={rowClassName}
                  createButton={
                    {
                      // label: "Crear Cargo",
                      // onClick: createHandlder,
                      // permission: "charge.create",
                    }
                  }
                  backButton={
                    {
                      // label: "Regresar",
                      // onClick: backHanlder,
                      // permission: "goBack",
                    }
                  }
                />
              </>
              )}

            {orden.id === null ||
              orden.id === undefined ||
              (orden.id <= 0 && <Loading />)}
            <DialogModal
              email={userInfo.Email}
              header="Agregar Participante"
              visible={visibleUser}
              setVisible={setVisibleUser}
              addUserHandler={addUserHandler}
              refresh={refresh}
            />
            <div
              style={{
                display: "flex",
                gap: "3%",
                marginTop: "3%",
                justifyContent: "space-between",
              }}
            >
              <Button
                className={styles.cardBackButton}
                label="Regresar"
                onClick={() =>
                  window.location.href = "/orders"}
              />
              <Button
                className={styles.buttonPay}
                label="Continuar"
                onClick={() => {
                  oldDiscountCode = orden.discountCode;
                  console.log(oldDiscountCode);
                  stepperRef.current.nextCallback();
                }}
                disabled={!orden?.users?.[0]?.id}

              />
            </div>
          </div>
        </StepperPanel>
        <StepperPanel header="paymentMethodSelector">
          <div className={styles.CreditCardPaymentQuote}>
            <h1 className={styles.formTitle}>Seleccione un método de pago</h1>
            <div className={styles.paymentOptions}>
              <Button className={styles.paymentButton} onClick={() => setSelectedPaymentMethod(1)}>
                <i className={`pi pi-credit-card ${styles.iconLarge}`} style={selectedPaymentMethod === 1 ? { color: '#1f3564' } : {}}></i>
                <h1 className={styles.paymentButtonName} style={selectedPaymentMethod === 1 ? { color: '#1f3564' } : {}}>Tarjeta de crédito</h1>
              </ Button>
              <Button className={styles.paymentButton} onClick={() => setSelectedPaymentMethod(2)}>
                <i className={`pi pi-receipt ${styles.iconLarge}`} style={selectedPaymentMethod === 2 ? { color: '#1f3564' } : {}}></i>
                <h1 className={styles.paymentButtonName} style={selectedPaymentMethod === 2 ? { color: '#1f3564' } : {}}>Transferencia bancaria</h1>
              </ Button>
            </div>
            <div
              style={{
                display: "flex",
                gap: "3%",
                marginTop: "3%",
                justifyContent: "space-between",
              }}
            >
              <Button
                className={styles.cardBackButton}
                label="Regresar"
                onClick={() => stepperRef.current.prevCallback()}
              />
              <Button
                className={styles.buttonPay}
                label="Continuar"
                onClick={() => selectedPaymentMethod == 1 || selectedPaymentMethod == 2 ? stepperRef.current.nextCallback() : dispatch(uiActions.showNotification({ status: "warning", title: "Seleccione un método de pago", message: "Debe seleccionar un método de pago para continuar" }))}
              />
            </div>
          </div>
        </StepperPanel>
        <StepperPanel header="paymentBillingInfo">
          <div className={styles.buyCourse}>
            <div className={styles.billingForm}>
              <h1 className={styles.formTitle}>Información de facturación</h1>
              <form className={styles.billingFormInfo}>
                <div className={styles.billingColumn}>
                  <label htmlFor="nombre">Nombre</label>
                  <InputText
                    onChange={(e) => onChangeHandler("name", e.target.value)}
                    value={user.name}
                    type="text"
                    id="name"
                    invalid={invalidField === "name"}
                  />
                </div>

                <div className={styles.billingColumn}>
                  <label htmlFor="apellido">Apellido</label>
                  <InputText
                    onChange={(e) => onChangeHandler("lastName", e.target.value)}
                    value={user.lastName}
                    type="text"
                    id="lastName"
                    invalid={invalidField === "lastName"}
                  />
                </div>

                <div className={styles.billingColumn}>
                  <label htmlFor="email">Email</label>
                  <InputText
                    onChange={(e) => onChangeHandler("email", e.target.value)}
                    value={user.email}
                    type="text"
                    id="email"
                    invalid={invalidField === "email"}
                  />
                </div>
                <div className={styles.billingColumn}>
                  <label htmlFor="telefono">Teléfono</label>
                  <InputMask
                    id="cellPhone"
                    value={user.cellPhone}
                    onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                    mask="+1999-999-9999"
                    placeholder="+1999-999-9999"
                    invalid={invalidField === "cellPhone"}
                  />
                </div>

                <div className={styles.billingColumn}>
                  <label htmlFor="pais">País</label>
                  <Dropdown
                    value={selectedCountry}
                    onChange={(e) => {
                      onChangeCountriesHandler("countryid", e.value);
                    }}
                    options={countries}
                    optionLabel="name"
                    placeholder="Seleccionar pais"
                    valueTemplate={selectedCountryTemplate}
                    filter
                    itemTemplate={countryOptionTemplate}
                    className={styles.billingDropdown}
                    invalid={invalidField === "country"}
                  />
                </div>

                {/* <div className={styles.billingColumn}>
                <label htmlFor="ciudad">Ciudad</label>
                <InputText
                  onChange={(e) => onChangeHandler("city", e.target.value)}
                  value={user.City}
                  type="text"
                  id="city"
                  invalid={invalidField === "city"}
                />
              </div> */}
                <div className={styles.billingColumn}>
                  <label htmlFor="direccion">Dirección</label>
                  <InputText
                    onChange={(e) => onChangeHandler("address", e.target.value)}
                    value={user.address}
                    type="text"
                    id="address"
                    invalid={invalidField === "address"}
                  />
                </div>


                <div className={styles.billingColumn}>
                  <Checkbox onChange={e => checkHandler(e)} checked={loadUserInfo}></Checkbox>
                  <label htmlFor="ingredient2" className="ml-2">Cargar mis datos</label>
                </div>

              </form>
            </div>
            <div className={styles.billingColumn}>
            <label style={{"color" : discount.isValid || inputColor == false ? "#213765" : "#C00000"}} htmlFor="discountCode">Código de descuento {discount.isValid && inputColor == true ? "(Código Válido)": ""} {discount.isValid == false && inputColor == true ? "(Código Inválido)": ""}</label>                  <InputText
                    onChange={(e) => onChangeDiscountHandler("discountCode", e.target.value)}
                    value={orden.discountCode !== undefined &&
                      orden.discountCode !== ""
                      ? orden.discountCode
                      : ""}
                    type="text"
                    id="address"
                    invalid = {discount.isValid || inputColor == false ? false : true}
                    />
                </div>
            <div
              style={{
                display: "flex",
                gap: "3%",
                marginTop: "3%",
                justifyContent: "space-between",
              }}
            >
              <Button
                className={styles.cardBackButton}
                label="Regresar"
                onClick={() =>
                  stepperRef.current.prevCallback()
                }
              />
              <Button
                className={styles.buttonPay}
                label="Continuar"
                onClick={() =>
                  onSubmitBillingHandler()
                }
              />
            </div>
          </div>
        </StepperPanel>
        {
          selectedPaymentMethod == 1 ? (
            <StepperPanel header="paymentCreditCard">
              {orden.id <= 0 && (
                <>
                  <Loading />
                </>
              )}
              {orden.courseId == param.courseid &&
                orden.userId == userInfo.UserId ? (
                <div className={styles.CreditCardPaymentQuote}>
                  <h1 className={styles.formTitle}>Pago con tarjeta</h1>
                  <div className={styles.facturationForm}>
                    <Card className={styles.card}>
                      <div className={styles.contentContainer}>
                        <form className={styles.forms}>
                          <div className={styles.column}>
                            <label htmlFor="orderNumber">Número de orden</label>
                            <h1>#{orden.id}</h1>
                          </div>
                          <div className={styles.column}>
                            <label htmlFor="orderNumber">Tasa</label>
                            <h1>{orden.dollarRate} RD$</h1>
                          </div>
                          {
                            orden.discount && orden.discount.id !== 0 && (
                              <div className={styles.column}>
                                <label htmlFor="dolarAmount">Subtotal</label>
                                <h1>{"$" + orden.amount.toFixed(2) + " USD"}</h1>
                              </div>
                            )
                          }

                          {
                            orden.discount && orden.discount.id !== 0 && (
                              <div className={styles.column}>
                                <label htmlFor="dolarAmount">Descuento {"(" + orden.discountCode + ")"}</label>
                                <h1>{"$" + (orden.amount - amountDollar).toFixed(2) + " USD "}</h1>
                              </div>
                            )
                          }
                          <div className={styles.column}>
                            <label htmlFor="dolarAmount">Total en dólares</label>
                            <h1>{USDollar.format(amountDollar) + " USD"}</h1>
                          </div>
                          <div className={styles.column}>
                            <label htmlFor="pesosAmount">Monto en pesos</label>
                            <h1>{USDollar.format(amountRD)}</h1>
                          </div>
                        </form>
                        <icon
                          className={`pi pi-credit-card ${styles.creditCardIcon}`}
                        ></icon>
                      </div>
                    </Card>

                    <form action={process.env.REACT_APP_PAYMET_URL} method="post">
                      <input
                        type="hidden"
                        id="MerchantId"
                        name="MerchantId"
                        value={process.env.REACT_APP_MERCHANTID_AULAABA}
                      />
                      <input
                        type="hidden"
                        id="MerchantName"
                        name="MerchantName"
                        value={process.env.REACT_APP_MERCHANT_NAME}
                      />
                      <input
                        type="hidden"
                        id="MerchantType"
                        name="MerchantType"
                        value={process.env.REACT_APP_MERCHANT_TYPE}
                      />
                      <input
                        type="hidden"
                        id="CurrencyCode"
                        name="CurrencyCode"
                        value="$"
                      />
                      <input
                        type="hidden"
                        id="OrderNumber"
                        name="OrderNumber"
                        value={orden.id}
                      />
                      <input
                        type="hidden"
                        id="Amount"
                        name="Amount"
                        value={amountToPay.replace(".", "")}
                      />
                      <input
                        type="hidden"
                        id="ITBIS"
                        name="ITBIS"
                        value={process.env.REACT_APP_MERCHANT_ITBIS}
                      />
                      <input
                        type="hidden"
                        id="ApprovedUrl"
                        name="ApprovedUrl"
                        value={ApprovedUrl}
                      />
                      <input
                        type="hidden"
                        id="DeclinedUrl"
                        name="DeclinedUrl"
                        value={DeclinedUrl}
                      />
                      <input
                        type="hidden"
                        id="CancelUrl"
                        name="CancelUrl"
                        value={CancelUrl}
                      />

                      <input
                        type="hidden"
                        id="UseCustomField1"
                        name="UseCustomField1"
                        value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD1}
                      />
                      <input
                        type="hidden"
                        id="CustomField1Label"
                        name="CustomField1Label"
                        value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD1_LABEL}
                      />
                      <input
                        type="hidden"
                        id="CustomField1Value"
                        name="CustomField1Value"
                        value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD1_VALUE}
                      />
                      <input
                        type="hidden"
                        id="UseCustomField2"
                        name="UseCustomField2"
                        value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD2}
                      />
                      <input
                        type="hidden"
                        id="CustomField2Label"
                        name="CustomField2Label"
                        value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD2_LABEL}
                      />
                      <input
                        type="hidden"
                        id="CustomField2Value"
                        name="CustomField2Value"
                        value={process.env.REACT_APP_MERCHANT_USECUSTOMFIELD2_VALUE}
                      />

                      <input
                        type="hidden"
                        id="AuthHash"
                        name="AuthHash"
                        value={GetHashCursos(
                          orden.id,
                          amountToPay,
                          CancelUrl,
                          ApprovedUrl,
                          DeclinedUrl
                        )}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: "3%",
                          marginTop: "3%",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          className={styles.cardBackButton}
                          label="Regresar"
                          onClick={() => stepperRef.current.prevCallback()}
                        />
                        <Button
                          className={styles.buttonPay}
                          label="Continuar"
                        // onClick={() => stepperRef.current.nextCallback()}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              ) : null}
            </StepperPanel>
          ) : (
            <StepperPanel header="paymentTransfer">
              <div>
                <Dialog header="Información" visible={showTutorial} style={{ width: "80%", height: "auto " }} onHide={() => setShowTutorial(false)}>
                  <div className={styles.transferInfo}>
                    <h2>Pasos a seguir para realizar el pago</h2>
                    <ol className="ordenTransferInfo">
                      <li>
                        Realizar la transferencia a una de nuestras cuentas:
                        <ul>
                          <li>
                            <strong>Banco BHD</strong>
                            <ul>
                              <li>
                                <strong>Cuenta Ahorro en dólares (US$):</strong>{" "}
                                0025893-0029
                              </li>
                              <li>
                                <strong>Cuenta Pesos Dominicanos</strong>{" "}
                                0025893-0070
                              </li>
                            </ul>
                          </li>
                        </ul>
                        <ul>
                          <li>
                            <strong>Banco Popular</strong>
                            <ul>
                              <li>
                                <strong>Cuenta Pesos Dominicanos</strong>{" "}
                                0114967-9
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <p className="ordenTransferInfo">
                        Ambas cuentas están a nombre de ABA <strong>RNC 401-053365</strong>, Banco Beneficiario: <strong>Banco BHD , S. A. </strong>
                        Swift: <strong>BCBHDOSDXXX </strong> o  Banco Beneficiario: <strong>Banco Popular Dominicano</strong>.  Favor incluir como
                        referencia del pago el número de orden asignado.
                      </p>
                      <li>
                        Hacer clic en el botón seleccionar al lado de comprobante de pago y subir el comprobante de pago de la transferencia.

                      </li>
                      <img style={{ width: "100%" }} src={tutorialImg1} alt="transferencia" border="0" />
                    </ol>

                  </div>
                </Dialog>
                <div style={{ marginTop: "10%", display: "flex" }}>
                  <h1 className={styles.formTitle}>Pago con transferencia bancaria</h1>
                  <Button onClick={() => setShowTutorial(true)} className={styles.infoButton}>?</Button>
                </div>
                <div className={styles.facturationForm}>

                  <Card className={styles.card}>

                    <div className={styles.contentContainer}>
                      <form className={styles.forms}>
                        <div className={styles.column}>
                          <label htmlFor="orderNumber">Número de orden</label>
                          <h1>#{orden.id}</h1>
                        </div>
                        <div className={styles.column}>
                          <label htmlFor="orderNumber">Tasa</label>
                          <h1>{orden.dollarRate} RD$</h1>
                        </div>
                        <div className={styles.column}>
                          <label htmlFor="dolarAmount">Monto en dólares</label>
                          <h1>{USDollar.format(amountDollar) + " USD"}</h1>
                        </div>
                        <div className={styles.column}>
                          <label htmlFor="pesosAmount">Monto en pesos</label>
                          <h1>{USDollar.format(amountRD)}</h1>
                        </div>
                        <div className={styles.column}>
                          <label>Comprobante de pago</label>
                          <FileUpload
                            ref={fileUploadRef}
                            // itemTemplate={itemTemplate}
                            maxFileSize={1000000}
                            // onUpload={{onTemplateUpload}}
                            // onError={onTemplateClear}
                            // onClear={onTemplateClear}
                            // headerTemplate={headerTemplate}
                            // accept=".pdf"
                            // customUpload={true}
                            // onSelect={onSelectHandler}
                            mode="basic"
                            chooseLabel="Subir"
                            // chooseOptions={chooseOptions}
                            // uploadOptions={uploadOptions}
                            // cancelOptions={cancelOptions}
                            // emptyTemplate={<p className="m-0">Seleccione el documento a enviar.</p>}
                            className={styles.fileUpload}
                          />

                        </div>

                      </form>
                      <icon className={`pi pi-wallet ${styles.creditCardIcon}`}></icon>
                    </div>
                  </Card>

                  <div
                    style={{
                      display: "flex",
                      gap: "3%",
                      marginTop: "3%",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      className={styles.cardBackButton}
                      label="Regresar"
                      onClick={() => stepperRef.current.prevCallback()}
                    />
                    <Button
                      className={styles.buttonPay}
                      label="Finalizar"
                      onClick={async () => {
                        if (
                          fileUploadRef.current &&
                          fileUploadRef.current.getFiles().length > 0
                        ) {
                          const [file] = fileUploadRef.current.getFiles();
                          await dispatch(UploadFileOrder(file, orden.id, userInfo.Email));
                          await dispatch(UpdatePaymenMethod(orden.id, 2, userInfo.Email));
                          window.location.href = "/transferenceRequested";
                        } else {
                          dispatch(
                            uiActions.showNotification({
                              status: "warning",
                              title: "Advertencia",
                              message: "Por favor adjunte un comprobante de pago.",
                            })
                          );
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </StepperPanel>
          )
        }

      </Stepper>
    </>
  );
};

export default CreditCardPaymentQuote;
